<a [href]="href()" [target]="target()" class="text-btn text-btn-not-inline" [attr.title]="tooltip()" longPress
	(longPress)="onLongPress($event)" (click)="click($event)">
	<i [class]="iconClass()"></i>
	<span class="icon-text">{{ iconText() }}</span>
</a>